import React from 'react';
import PropTypes from 'prop-types';

const FormInputHelp = ({ children = '', errorText = '', hide = false }) => {
  if (hide) {
    return null;
  }

  return (
    <div className="help-block">
      {errorText && <span className="error-text">{errorText} </span>}
      <span className="help-text">{children}</span>
    </div>
  );
};

FormInputHelp.defaultProps = {
  children: '',
  errorText: '',
  hide: false,
};

FormInputHelp.propTypes = {
  children: PropTypes.any,
  errorText: PropTypes.string,
  hide: PropTypes.bool,
};

export default FormInputHelp;
